import React, { useState, useEffect } from "react";
import { Accordion, Button, Col, Row, Spinner } from "react-bootstrap";
import DeleteQuickAlerts from "../deleteQuickAlerts";
import { useQuickAlertsRow } from "./useQuickAlertsRow";
import SendAlertConfirmationModal from "../sendAlertConfirmation";
import { IGroupAlerts } from "../../../../common/types/alertsTypes";
import { AlertTemplateData } from "../../../../common/alertTemplateData";
import { GripVertical, Pencil } from "lucide-react";

interface IProps {
  item: any;
  index: number;
  isActive: boolean;
  onClose: () => void;
  onDeleteSuccess: () => void;
}

const QuickAlertRow = (props: IProps) => {
  const { item, index, isActive, onClose, onDeleteSuccess } = props;
  const {
    onEditQuickAlert,
    handleSendAlert,
    truncateMessage,
    capitalizeSeverity,
  } = useQuickAlertsRow(item);

  const [showConfirmation, setShowConfirmation] = useState(false);
  const [modalGroups, setModalGroups] = useState<IGroupAlerts[]>([]);

  const [shouldLoadContent, setShouldLoadContent] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isActive && !shouldLoadContent) {
      setLoading(true);
      setTimeout(() => {
        setShouldLoadContent(true);
        setLoading(false);
      }, 150);
    }
  }, [isActive]);

  const onSendButtonClick = () => {
    setModalGroups(item.groups || []);
    setShowConfirmation(true);
  };

  const onConfirmSend = (updatedGroups: IGroupAlerts[]) => {
    handleSendAlert({ ...item, groups: updatedGroups });
    setShowConfirmation(false);
  };

  return (
    <Row key={index.toString()}>
      <Col sm={2} style={{justifyItems: "center", marginTop: "1%" }}>
        <div className="create-alerts-btn">
          <Button onClick={onSendButtonClick}>{item.alertButtonName}</Button>
        </div>
      </Col>
      <Col sm={8}>
        <Accordion activeKey={isActive ? index.toString() : undefined}>
          <Accordion.Item eventKey={index.toString()}>
            <Accordion.Header
              as="div"
              onClick={() => onEditQuickAlert()}
            >
              <div className="integration-heading d-flex justify-content-between align-items-center w-100">
                <div className="integration-list d-flex flex-wrap">
                  <span>{`Alert Message: ${truncateMessage(item.alertMessage)}`}</span>
                  <span className="mx-2">/</span>
                  <span>{`Severity: ${capitalizeSeverity(item.severity)}`}</span>
                  <span className="mx-2">/</span>
                  <span>{`Groups (${item.groups?.length})`}</span>
                  <span className="mx-2">/</span>
                  <span>{AlertTemplateData[`template:${item?.templateId}`]?.name}</span>
                </div>
                <span
                role="button"
                tabIndex={0}
                className="bg-transparent border-0 p-0 m-0 d-flex align-items-center"
                onClick={(e) => {
                  e.stopPropagation();
                  onEditQuickAlert();
                }}
              >
                <Pencil size={18} />
              </span>
              </div>
            </Accordion.Header>
            <Accordion.Body>
              {loading && (
                <div className="text-center p-3">
                  <Spinner animation="border" size="sm" />
                </div>
              )}

              {shouldLoadContent && !loading && (
                <div>
                  <strong>Alert Title:</strong> {item.alertTitle} <br />
                  <strong>Groups:</strong> {item.groups?.length} <br />
                </div>
              )}
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Col>

      <Col sm={1} style={{ marginTop: "1%" }}>
      <DeleteQuickAlerts
        alertId={item._id}
        alertTitle={item.alertTitle}
        onDeleteSuccess={onDeleteSuccess}
      />
      </Col>
      <Col sm={1} style={{ marginTop: "1%" }}>
        <GripVertical size={21} />
      </Col>

      {showConfirmation && (
        <SendAlertConfirmationModal
          show={showConfirmation}
          onConfirm={onConfirmSend}
          onCancel={() => setShowConfirmation(false)}
          alertTitle={item.alertTitle}
          initialGroups={modalGroups}
        />
      )}
    </Row>
  );
};

export default QuickAlertRow;
